module.exports = __webpack_public_path__ + "static/media/bio_bg.095a8d53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bio_bg.jpg
// module id = 5958
// module chunks = 0